export default __webpack_public_path__ + "static/media/rain.2e2a2c83.svg";